import React from "react";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import { useSelector } from "react-redux";
import { selectIsAuthenticated } from "../../store/slices/authSlice";
import { images } from "../../constants/index";
import "./404Error.css";

const NoMatch = () => {
  const navigate = useNavigate();
  const isAuthenticated = useSelector(selectIsAuthenticated);

  return (
    <>
      <Helmet>
        <title>404 - Page Not Found | SelectEzi</title>
        <meta
          name="description"
          content="The page you are looking for might have been removed, had its name changed, or is temporarily unavailable."
        />
      </Helmet>

      <div className="error-page-container">
        <div className="error-card">
          <div className="error-illustration-container">
            <img
              src={images.ErrorImg}
              alt="404 Illustration"
              className="error-svg"
              loading="lazy"
            />
          </div>

          <h1 className="error-title">404</h1>
          <h2 className="error-subtitle">Page Not Found</h2>

          <p className="error-description">
            Oops! The page you are looking for doesn't exist, has been moved,
            or is temporarily unavailable. Let's get you back on track.
          </p>

          <div className="error-actions">
            {isAuthenticated ? (
              <button
                onClick={() => navigate("/BuyingSide")}
                className="error-btn-primary"
              >
                Go to Dashboard
              </button>
            ) : (
              <button
                onClick={() => navigate("/login")}
                className="error-btn-primary"
              >
                Login Now
              </button>
            )}
            <button
              onClick={() => navigate(-1)}
              className="error-btn-secondary"
            >
              Go Back
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default NoMatch;
